import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { useFlatCardContext } from '../../hooks/useFlatCardContext/useFlatCardContext';
import { useSidebarMode } from '../../hooks/useSidebarMode';

export const VisibilityToggle = (): JSX.Element | null => {
  const flatCard = useFlatCardContext();

  if (useSidebarMode() !== 'customization' || !flatCard) {
    return null;
  }

  // The toggle reflects the agent's own choice (ignoring conditions) so a
  // condition-hidden card can still be toggled.
  const isHidden = flatCard.isUserHidden;

  const tooltipContent =
    flatCard.isConditionHidden && !isHidden
      ? 'Conditionally hidden. Card still shows when the conditions match.'
      : isHidden
        ? 'Show card'
        : 'Hide card';

  return (
    <Tooltip content={tooltipContent}>
      <IconButton
        icon={isHidden ? 'eye-slash' : 'eye'}
        variant="tertiary"
        onClick={(event) => {
          event.stopPropagation();
          flatCard.toggleVisibility();

          ampli.conversationRightSidebarItemVisibilityToggled({
            isVisible: isHidden,
            sidebarItemType: 'card',
          });
        }}
      />
    </Tooltip>
  );
};
